import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon-persion.png';
const _withScopeId = n => (_pushScopeId("data-v-c95db0be"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "one"
};
const _hoisted_3 = {
  class: "buttons"
};
const _hoisted_4 = {
  class: "chart"
};
const _hoisted_5 = {
  class: "two"
};
const _hoisted_6 = {
  class: "store-name"
};
const _hoisted_7 = {
  class: "product-name"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  class: "details"
};
const _hoisted_11 = {
  class: "details"
};
const _hoisted_12 = {
  class: "details"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  const _component_active_rate_chart = _resolveComponent("active-rate-chart");
  const _component_Cell = _resolveComponent("Cell");
  const _component_List = _resolveComponent("List");
  const _component_Empty = _resolveComponent("Empty");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Button, {
    type: "primary",
    plain: $data.errorType === 2,
    class: "btn-item left_radius",
    onClick: $options.toggleTab
  }, {
    default: _withCtx(() => [_createTextVNode("位置异常（" + _toDisplayString($data.listData1.length) + "）", 1)]),
    _: 1
  }, 8, ["plain", "onClick"]), _createVNode(_component_Button, {
    type: "primary",
    plain: $data.errorType === 1,
    class: "btn-item right_radius",
    onClick: $options.toggleTab
  }, {
    default: _withCtx(() => [_createTextVNode("未结束任务（" + _toDisplayString($data.listData2.length) + "）", 1)]),
    _: 1
  }, 8, ["plain", "onClick"])]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createVNode(_component_active_rate_chart, {
    ref: "chart1",
    data: $data.chartData1,
    id: "chart1"
  }, null, 8, ["data"]), [[_vShow, $data.errorType === 1]]), _withDirectives(_createVNode(_component_active_rate_chart, {
    ref: "chart2",
    data: $data.chartData2,
    id: "chart2"
  }, null, 8, ["data"]), [[_vShow, $data.errorType === 2]])])]), _createElementVNode("div", _hoisted_5, [$options.listData.length ? (_openBlock(), _createBlock(_component_List, {
    key: 0,
    class: "store-list",
    "finished-text": "没有更多了"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.listData, (item, index) => {
      return _openBlock(), _createBlock(_component_Cell, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(item.storeName), 1), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(item.positionType), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, "任务触点：" + _toDisplayString(item.pgName || '-'), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, "任务开始：" + _toDisplayString(item.attStartTime || '--:--'), 1), _createElementVNode("span", {
          class: _normalizeClass(["status", {
            error: item.isStartNormal === 0
          }])
        }, _toDisplayString(item.isStartNormal === 1 ? '正常' : $data.errorType === 1 ? '≤ 1Km 偏离' : '无记录'), 3)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, "任务结束：" + _toDisplayString(item.attEndTime || '--:--'), 1), _createElementVNode("span", {
          class: _normalizeClass(["status", {
            error: item.isOffNormal === 0
          }])
        }, _toDisplayString(item.isOffNormal ? '正常' : $data.errorType === 1 ? '≤ 1Km 偏离' : '无记录'), 3)])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_Empty, {
    key: 1,
    description: "暂无数据"
  }))])]);
}